/**
 * MED-922 - the little logic the patient notes panel and the invoice-screen popup share.
 *
 * Kept out of the components so it can be tested without a DOM.
 */

/**
 * The notes that force a modal when an invoice for the patient is viewed.
 *
 * Order is preserved rather than re-sorted: the API lists newest first, and the modal should
 * lead with the newest. A missing `isPopup` reads as off - the API omits null fields, and a note
 * that was never flagged must not fire.
 */
export const popupNotes = (notes) => (Array.isArray(notes) ? notes.filter((note) => note && note.isPopup === true) : []);

export const hasPopupNotes = (notes) => popupNotes(notes).length > 0;

export const noteLines = (note) => (note && typeof note.note === 'string' ? note.note.split('\n') : []);
